// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"81698ef6","588":"979cb6f7","719":"efe1d848"}[chunkId] + ".chunk.js";
};